import i18n from 'lang/i18n'

export default {
    UNKNOWN: { title: i18n.t('error.unknown.title'), text: i18n.t('error.unknown.text') },
    UNAUTHORIZED: { title: i18n.t('error.unauthorized.title'), text: i18n.t('error.unauthorized.text') },
    NICK_COLLISION: { title: i18n.t('error.nickCollision.title'), text: i18n.t('error.nickCollision.text') },
    MC_UNAUTHORIZED: { title: i18n.t('error.mcUnauthorized.title'), text: i18n.t('error.mcUnauthorized.text') },
    MC_USERNAME_COLLISION: { title: i18n.t('error.mcUsernameCollision.title'), text: i18n.t('error.mcUsernameCollision.text') },
    GAME_NOT_FOUND: { title: i18n.t('error.mcGameNotFound.title'), text: i18n.t('error.mcGameNotFound.text') }
}



// WEBPACK FOOTER //
// src/utils/errors.js